module.exports = __webpack_public_path__ + "img/cloud-snow.0722b483.svg";